import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye, FaEdit } from 'react-icons/fa';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import formatForMask from '~/utils/formatForMask';
import { loadGerentes } from '~/store/modules/gerente/action';
import Create from '../Create';
import Edit from '../Edit';
import Show from '../Show';

const List = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  let modal = location.state && location.state.modal;
  const breadcrumb = {
    label: 'Lista',
    to: '/gerentes',
    active: false,
  };
  const { user_auth } = useSelector(
    ({ LoginReducer }) => LoginReducer
  );
  const { gerentes, gerente } = useSelector(
    ({ GerenteReducer }) => GerenteReducer
  );

  useEffect(() => {
    dispatch(loadGerentes({
      with: 'pessoa',
      where: `tipo_user_id:4,entidade_id:${user_auth.user.entidade_id}`
    }));
  }, [dispatch, user_auth.user.entidade_id, gerente]);

  return (
    <>
      {modal && (
        <Switch>
          <Route
            children={<Create />}
            path="/gerentes/create"
          />
          <Route
            children={<Edit />}
            exact
            path="/gerentes/:gerente_id/edit"
          />
          <Route
            children={<Show />}
            exact
            path="/gerentes/:gerente_id/detalhe"
          />

        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>
            <div className="card-tools">
              <Link
                className="btn btn-success"
                to={{
                  pathname: '/gerentes/create',
                  state: { modal: true },
                }}
              >
                <i className="fa fa-plus" /> Novo
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>CNPJ/CPF</th>
                    <th>Email</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {gerentes.data && gerentes.data.map((gerente, index) => (
                    <tr key={index}>
                      <td>{gerente.id}</td>
                      <td>{gerente.nome}</td>
                      <td>
                        {gerente.pessoa && gerente.pessoa.cnpj ?
                          formatForMask(
                            gerente.pessoa.cnpj,
                            '##.###.###/####-##'
                          ) : ''
                        }
                        {gerente.pessoa && gerente.pessoa.cpf ?
                          formatForMask(
                            gerente.pessoa.cpf,
                            '###.###.###-##'
                          ) : ''
                        }
                      </td>
                      <td>{gerente.email}</td>
                      <td>
                        <div className="btn-group float-right">
                          <Link
                            className="btn btn-default"
                            to={{
                              pathname: `/gerentes/${gerente.id}/edit`,
                              state: { modal: true },
                            }}
                          >
                            <FaEdit /> Editar
                          </Link>
                          <Link
                            className="btn btn-info"
                            to={{
                              pathname: `/gerentes/${gerente.id}/detalhe`,
                              state: { modal: true },
                            }}
                          >
                            <FaEye /> Detalhes
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {!gerentes && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate
              load={() => loadGerentes({
                with: 'pessoa',
                where: `tipo_user_id:4,entidade_id:${user_auth.user.entidade_id}`
              })}
              meta={gerentes.meta}
            />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
